import authRules from '../authRules.js';

const addDayTypeRequest = (user) => {
  const { absenceRequests } = user.securityLevels;
  if (absenceRequests >= authRules.addDayTypeRequest.absenceRequests) {
      return true;
  } else {
      return false;
    }
  }


export default addDayTypeRequest;
